/**
 *
 * Validação da força do campo password.
 * É validado se a password tem uma letra minúscula,
 * se tem uma letra maiúscula, se tem um número e se tem
 * um carácter especial.
 *
 * @param {String} value
 * @output {Boolean}
 *
*/

const validateStrenghtPassword = value => {
    if ( !value )
        return true;

    return value.length >= 8
        && /[a-z]/.test( value )
        && /[A-Z]/.test( value )
        && /[0-9]/.test( value )
        && /[$€&+,:;_=?@#/|'"<>.^*()%!-]/.test( value );
};

export default {
    validateStrenghtPassword
};